import React, { useMemo, useRef, useState } from 'react'
import { Autocomplete, Box, Button, Stack, TextField } from '@mui/material';
import { Ttrack } from '../../shared/types/tracks.type';
import { t } from 'i18next';
import { TTrainingType } from '../../shared/types/training.type';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { Icon } from '@iconify/react';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { getCorrectDateFormat } from '../../shared/utils/DateUtils';

type ComparaisonHorseFiltersProps = {
    tracks: Ttrack[],
    trainingTypes: TTrainingType[],
    selectedTracks: Ttrack[],
    selectedTrainingTypes: TTrainingType[],
    onTracksChange: (values: Ttrack[]) => void
    onTrainingTypesChange: (values: TTrainingType[]) => void,
    onReset: () => void,
    onSave: () => void,
    onStartDateChange: (value: unknown) => void,
    onEndDateChange: (value: unknown) => void,
    startDate: unknown | null,
    endDate: unknown | null,
    isFiltersEmpty: boolean,
}

function ComparaisonHorseFilters({ isFiltersEmpty, tracks, trainingTypes, selectedTracks, selectedTrainingTypes, onTracksChange, onTrainingTypesChange, onReset, onSave, startDate, endDate, onStartDateChange, onEndDateChange }: ComparaisonHorseFiltersProps) {

    const ref = useRef<any>(undefined)

    const dateFormat = useSelector<RootState>(state => state.user.user?.default_date_format) as string | undefined


    const getDateFormat = (): string => {
        if (dateFormat) {
            return getCorrectDateFormat(dateFormat)
        } else {
            return 'DD/MM/YYYY'
        }
    }

    return (
        <Stack direction={'column'} spacing={2} p={2} style={{ position: 'relative' }}>

            <DatePicker format={getDateFormat()} value={typeof (startDate) === 'string' ? dayjs(startDate) : startDate} onChange={(value) => {
                ref.current?.focus()
                onStartDateChange(value)
            }

            } label={t('riders:startDate')} />
            <DatePicker format={getDateFormat()} inputRef={ref} value={typeof (endDate) === 'string' ? dayjs(endDate) : endDate} onChange={(value) => onEndDateChange(value)} label={t('riders:endDate')} />
            <Autocomplete
                disablePortal
                options={tracks}
                getOptionKey={option => option.id}

                multiple
                sx={{ width: '300px' }}
                onChange={(_, values) => onTracksChange(values)}
                value={selectedTracks}
                getOptionLabel={option => option.display_name}
                renderInput={(params) => <TextField {...params} label={t('tracks')} />}
            />

            <Autocomplete
                disablePortal
                options={trainingTypes}
                getOptionKey={option => option.id}
                multiple
                sx={{ width: '300px' }}
                onChange={(_, values) => onTrainingTypesChange(values)}
                value={selectedTrainingTypes}
                getOptionLabel={option => option.display_name}
                renderInput={(params) => <TextField {...params} label={t('trainingTypes')} />}
            />

            <Box display={'flex'} justifyContent={'end'} alignItems={'center'} gap={2}>
                <Button disabled={isFiltersEmpty} startIcon={<Icon icon={'ic:baseline-clear-all'}></Icon>} onClick={onReset}>{t('equimetre.reset.button')}</Button>
                <Button onClick={onSave} variant='contained'>{t('daterangepicker:applyLabel')}</Button>
            </Box>
        </Stack>
    )
}

export default ComparaisonHorseFilters